import identify from '~/identify';
import { version } from '~/../package.json';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { setTrans } from './translations';

export const defaultTableResults = {
    results: {},
    total: 0,
    last: 0,
    page: 1,
    isDefault: true,
};

export const defaultPromiseState = {
    status: null,
    started_at: null,
    finished_at: null,
    canceled_at: null,
    invalidated_at: null,
    error: null,
};

export const defaultTableResultsState = {
    ...defaultPromiseState,
    loadedParams: null,
    loadingParams: null,
    value: defaultTableResults,
};

export const helpInitialState = {
    term: '',
    category: '',
    mediaCategory: '',
    helpData: {
        ...defaultPromiseState,
        value: {
            total: 0,
            last: 0,
            page: 1,
            results: [],
        },
    },
};

export const defaultModel = {
    view: 'tabular',
};

export const DEFAULT_USER_META = {
    email: '',
    name: '',
    company: '',
    avatar: '',
};


const basePublicUrl = JSON.parse(JSON.stringify(process.env.BASE_PUBLIC_URL) || JSON.stringify(""));

const ENV_CONSTANTS = {
    development: {
        baseUrl: basePublicUrl ? new URL("/admin", basePublicUrl).href : "/admin",
        basePublicUrl: basePublicUrl || '',
    },
};

export const defaultPageState = {};

export const defaultConfig = {
    isDefaultConfig: true,
    version,
    cacheModels: false,
    adminThemeColor: '10, 100%, 27%',
    openMimeTypes: ['image', 'pdf'],
    baseUrl: '',
    basePublicUrl: '',
    title: 'WebSail',
    company: 'WebSail',
    logo: '/uploads/images/logo_admin.png',
    guest_logo: '',
    locale: 'websail',
    fallback_locale: 'de',
    middleIcon: 'veranstaltungsbutler',
    unique_id: 'ABCD',

    defaultGroup: 'default',
    defaultPage: { page: 'app', appPage: 'model', model: 'customers' },
    emptyPlaceholder: '-',
    obfuscateCookiePwShift: 12,
    supportNumber: '+49 30 22957151',
    showHarbour: false,
    maxPerPage: 100,
    errorReporting: {
        maxActionLog: 100,
    },

    user: DEFAULT_USER_META,

    inputTypes: {
        [identify.FILTERFIELD]: {
            data: 'dataModel.resultParams.filters',
            value: 'activeView.filters',
            options: 'filterOptions',
            initialValue: 'stateModel.resultParams.filters',
            startValues: 'stateModel.resultParams.filters',
        },
        [identify.EDITFIELD]: {
            data: 'itemData.value.editFields',
            value: 'item.values',
            initialValue: 'itemData.value.initialValues',
            startValues: 'itemData.value.values',
            options: 'item.options',
        },
    },

    errorSources: ['results', 'itemData', 'saveResult', 'deleteResult', 'itemCustomActionResult', 'customActionResult'],

    messageSources: ['authResult', 'itemData', 'saveResult', 'deleteResult', 'itemCustomActionResult', 'customActionResult'],
    excludeMessageTags: [['grid-action', 'customActionError']],

    ...ENV_CONSTANTS[process.env.NODE_ENV],
};

export const defaultFilterGroup = {
    name: 'default',
    title: 'Default',
    filters: [],
};

class Config {
    constructor() {
        Object.assign(globalThis, {
            logDirtyFields: this.logDirtyFields
        })
    }


    logDirtyFields = (shouldLog = true) => {
        this.configFromAPI = {
            ...this.configFromAPI,
            LOG_DIRTY_FIELDS: shouldLog,
        }
    }

    configFromAPI = null;
    set = (newConfig) => {
        this.configFromAPI =
            newConfig &&
            merge({}, defaultConfig, newConfig, ENV_CONSTANTS[process.env.NODE_ENV], { isDefaultConfig: false });
        setTrans();
    };

    get = () => {
        if (this.configFromAPI) {
            return this.configFromAPI;
        }

        if (window.wsconfig) {
            return merge({}, defaultConfig, { isDefaultConfig: false }, window.wsconfig);
        }

        return defaultConfig;
    };
}

let wsconfig = new Config();
export const setConfig = wsconfig.set;

export default wsconfig.get;
